import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Router, ActivatedRouteSnapshot } from '@angular/router';
import { UserReport, UserService } from 'src/app/core';

@Injectable({
  providedIn: 'root',
})
export class UserReportResolver  {
  constructor(private userService: UserService, private router: Router) {}

  resolve(route: ActivatedRouteSnapshot): Observable<UserReport> | undefined {
    const userId = route.params['id'];

    if (userId) {
      return this.userService.getUserReport(userId);
    }

    this.router.navigate(['/admin/users']);
    return undefined;
  }
}
